import { checkEmailRegex } from '../../../constants';

const footerContactFormSubmit = () => {
  // Clear Input
  const clearInput = (inputRef: JQuery) => {
    inputRef
      .css('border-color', '#fff')
      .parents('[placeholder]')
      .css('--placeholder-color', '#fff');
  };

  // Input Error
  const inputError = (inputRef: JQuery) => {
    inputRef
      .css('border-color', 'red')
      .parents('[placeholder]')
      .css('--placeholder-color', 'red');
  };

  // Footer Form Submit
  $('.tt-footer-v2__form-form').on('submit', function (e) {
    e.preventDefault();

    const spinner = $(this).find('.lds-dual-ring');

    spinner
      .css('display', 'inline-flex')
      .parent('.tt-footer-v2__form-submit')
      .trigger('blur');

    // Elements
    const fname = $('.tt-footer-v2__form-fname-input');
    const email = $('.tt-footer-v2__form-email-input');
    const firma = $('.tt-footer-v2__form-firma-input');
    const lang = $('.tt-footer-v2__form-lang-input');

    clearInput(fname);
    clearInput(email);
    clearInput(firma);
    clearInput(lang);

    const firmaVal = firma.val() as string;
    const fnameVal = fname.val() as string;
    const emailVal = email.val() as string;
    const langVal = lang.val() as string;

    let error = false;

    if (fnameVal.length == 0) {
      inputError(fname);
      error = true;
    }

    if (emailVal.length == 0 || !checkEmailRegex.test(emailVal)) {
      inputError(email);
      error = true;
    }

    if (firmaVal.length == 0) {
      inputError(firma);
      error = true;
    }

    if (error) {
      spinner.hide();
      return;
    }

    const params = {
      fname: fnameVal,
      email: emailVal,
      firma: firmaVal,
      lang: langVal,
    };

    $.post(`/ui/ContactUs@FormPost_v3`, params, function (data) {
      console.log('data');
      console.log(data);
      const obj = JSON.parse(data);
      console.log('json');
      console.log(obj);
      if (obj.result) {
        fname.val('');
        email.val('');
        firma.val('');
        lang.val('');
      }
      spinner.hide();
    });
  });
};

export default footerContactFormSubmit;
